<template>
    <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <router-link to="/about" class="black--text">About</router-link>
    <router-link to="/about" class="black--text">About</router-link>
    <router-link to="/about" class="white--text">About</router-link>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
  // import HelloWorld from '../components/HelloWorld'

  export default {
    name: 'Home',

    components: {
      // HelloWorld,
    },
  }
</script>
